(() => {
  if (!document.querySelector('#MainContent[data-template="product"]')) return;
  document.body.dataset.template = 'product';

  const emit = (name, detail = {}) => {
    document.dispatchEvent(new CustomEvent(`nn:${name}`, { detail }));
    window.Shopify?.analytics?.publish?.(`nn_${name}`, detail);
  };

  document.addEventListener('pointerup', (event) => {
    if (event.target.closest('nn-product-spin-viewer')) emit('product_spin_interaction');
  }, { passive: true });

  document.addEventListener('play', (event) => {
    if (event.target.matches('.product-information video')) {
      emit('product_video_play', { product: location.pathname });
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-picker')) emit('variant_selection');
    if (event.target.matches('[data-nn-charm-option] input')) {
      emit('charm_selection', { selected: event.target.checked });
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-nn-charm-picker] summary')) emit('charm_selector_open');
    if (event.target.closest('.add-to-cart-button')) emit('add_to_cart_attempt');
    if (event.target.closest('[data-nn-submit]')) emit('configuration_add_attempt');
  });

  const videos = [...document.querySelectorAll('.product-information video')];
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting && !target.paused) target.pause();
      });
    }, { threshold: .15 });
    videos.forEach((video) => observer.observe(video));
  }
})();
